import type {
    GetCommerceCustomerRegistrationRequest,
    GetCommerceCustomerRegistrationResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";

export const getCommerceCustomerRegistrationOperation = defineCommerceOperation<
    GetCommerceCustomerRegistrationRequest,
    GetCommerceCustomerRegistrationResponse
>("commerce.customer.registration.get");
